export default __webpack_public_path__ + "static/media/ourbrand-bg.03fde106.jpg";